<template>
  <div class="content">
    <div class="search-bar">
      <div class="row">
        <div class="col-md-6">
          <ArtistSelect
            v-model="selectedUnitId"
            @memberChangeEvent="onMemberChange"
            :include-unit-artist="true"
            :is-filter="true"
            :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
            :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
          />
        </div>
        <div class="col-md-2">
          <h4 class="card-title text-left">타입</h4>
          <div class="row">
            <el-select @change="onClickSearch" class="select-primary col-md-12 text-left" size="large" placeholder="선택" v-model="selectedTopicType">
              <el-option v-for="option in typeOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
        <div class="col-md-2">
          <h4 class="card-title text-left">세부타입</h4>
          <div class="row">
            <el-select @change="onClickSearch" class="select-primary col-md-12 text-left" size="large" placeholder="선택" v-model="selectedTopicSubType">
              <el-option v-for="option in subtypeOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
        <div class="col-md-2">
          <h4 class="card-title text-left">상태</h4>
          <div class="row">
            <el-select @change="onClickSearch" class="select-primary col-md-12 text-left" size="large" placeholder="선택" v-model="selectedState">
              <el-option v-for="option in stateOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <h4 class="card-title text-left">범위</h4>
          <div class="row">
            <el-select @change="onClickSearch" class="select-primary col-md-12 text-left" size="large" placeholder="선택" v-model="selectedPopularity">
              <el-option v-for="option in popularityOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
        <div class="col-md-4">
          <h4 class="card-title text-left">기간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-date-picker type="daterange" start-placeholder="검색 시작일" end-placeholder="검색 종료일" v-model="searchPeriod" />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <h4 class="card-title text-left">검색어</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-input placeholder="검색어를 입력해 주세요" v-model="searchText" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <h4 class="card-title text-left"></h4>
          <base-radio name="card" inline v-model="viewType">카드</base-radio>
          <base-radio name="list" inline v-model="viewType">리스트</base-radio>
        </div>
        <div class="col-md-8 text-right">
          <base-button @click.self="onClickSearch" native-type="submit" type="primary">검색</base-button>
        </div>
      </div>
    </div>
    <div class="list" v-if="viewType == 'card'">
      <div class="topic-cell" v-for="topic in topics" :key="topic.id">
        <div class="body">
          <card class="topic-card">
            <div class="cover-img-area">
              <div class="a-or-b" v-if="topic.ab">
                <h5>A/B</h5>
                <img class="img" :src="topic.ab.aFileId | blipImageUrl" />
                <img class="img" :src="topic.ab.bFileId | blipImageUrl" />
              </div>

              <div class="poll" v-if="topic.poll">
                <h5>POLL</h5>
              </div>

              <div class="question" v-if="topic.type === 21">
                <h5>TALK ({{ topic.talk.subtypeName }})</h5>
              </div>
            </div>
            <div class="metadata">
              <div class="title">
                <span class="id">[{{ topic.id }}] </span>
                <span class="name">{{ topic.title }}</span>
              </div>
              <div class="stats">
                <span>{{ topic.viewCount }} 뷰 / </span>
                <span>{{ topic.respondentCount }} 명 참여 / </span>
                <span>{{ topic.likeCount }} 좋아요 / </span>
                <span>{{ topic.commentCount }} 댓글 / </span>
                <span>{{ topic.pinCount }} 저장</span>
              </div>
              <div class="regTime">{{ topic.regTime }}</div>
            </div>
          </card>
        </div>

        <div class="delete">
          <base-button class="btn" @click.prevent="onClickDetail(topic)">상세</base-button>
          <base-button class="btn-danger" v-if="topic.state != -1" @click.prevent="onClickDelete(topic)">삭제</base-button>
        </div>
      </div>
    </div>
    <div class="row" v-if="viewType == 'list'">
      <div class="col-md-12" v-for="topic in topics" :key="topic.id">
        <div class="row">
          <div class="col-md-8">
            <div v-if="topic.ab">
              <h5>[{{ topic.id }}] A/B | {{ topic.title | truncate(80) }} ({{ topic.regTime }})</h5>
            </div>
            <div v-if="topic.poll">
              <h5>[{{ topic.id }}] POLL | {{ topic.title | truncate(80) }} ({{ topic.regTime }})</h5>
            </div>
            <div v-if="topic.type === 21">
              <h5>[{{ topic.id }}] TALK ({{ topic.talk.subtypeName }}) | {{ topic.title | truncate(80) }} ({{ topic.regTime }})</h5>
            </div>
          </div>
          <div class="col-md-4">
            <base-button class="btn" @click.prevent="onClickDetail(topic)">상세</base-button>
            <base-button class="btn-danger" v-if="topic.state != -1" @click.prevent="onClickDelete(topic)">삭제</base-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>

<script>
import { TopicTalkTypeOptions, TopicType, TopicTypeOptions } from "@/common/TopicTypes";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Toast } from "@/util/Toast";
import moment from "moment";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import { Card, BasePagination } from "@/components/index";
import swal from "sweetalert2";
import { formatDateTime } from "@/util/DateUtils";
import { URLUtils } from "@/util/URLUtils";
import * as _ from "lodash";
import { UserData } from "@/util/UserData";
import { TopicState, TopicStateOptions } from "@/common/TopicState";

const DEFAULT_UNIT_ID = 1;
const DEFAULT_TOPIC_TYPE = null;
const DEFAULT_TOPIC_STATE = TopicState.VISIBLE;

export default {
  name: "TopicContents",
  components: {
    ArtistSelect,
    Card,
    BasePagination,
  },
  async created() {
    this.viewType = UserData.get("currentViewType") ?? "card";
    const fallbackUnitId = UserData.get(UserData.LAST_UNIT_ID, DEFAULT_UNIT_ID);

    if (_.isEmpty(this.$route.query)) {
      await this.$router.replace(`/topic/contents?unitId=${fallbackUnitId}&state=1&popularity=0`);
      return;
    }

    const { unitId, artistId, topicType, topicSubtype, state, popularity, startDate, endDate, searchText } = this.$route.query;

    this.selectedUnitId = unitId ? parseInt(unitId, 10) : fallbackUnitId;
    this.selectedMemberId = artistId ? parseInt(artistId, 10) : null;
    this.selectedTopicType = topicType ? parseInt(topicType, 10) : DEFAULT_TOPIC_TYPE;
    this.selectedTopicSubType = topicSubtype ? topicSubtype : null;
    this.selectedPopularity = popularity ? parseInt(popularity, 10) : 0;
    this.selectedState = state ? parseInt(state, 10) : DEFAULT_TOPIC_STATE;
    if (startDate && endDate) {
      this.searchPeriod = [moment(startDate, "YYYY-MM-DD").toDate(), moment(endDate, "YYYY-MM-DD").toDate()];
    }
    this.searchText = searchText || null;

    await this.getTopics();
  },
  watch: {
    viewType: {
      handler() {
        UserData.set("currentViewType", this.viewType);
      },
    },
    selectedTopicType: {
      handler() {
        if (this.selectedTopicType === TopicType.TALK) {
          this.subtypeOptions = TopicTalkTypeOptions;
        } else {
          this.subtypeOptions = [{ label: "전체", value: null }];
          this.selectedTopicSubType = null;
        }
      },
    },
    currentPage: {
      handler() {
        this.getTopics();
      },
    },
  },
  data() {
    return {
      typeOptions: TopicTypeOptions,
      subtypeOptions: [{ label: "전체", value: null }],
      stateOptions: TopicStateOptions,
      popularityOptions: [
        { value: 0, label: "전체 토픽" },
        { value: 1, label: "인기 토픽" },
      ],
      selectedUnitId: DEFAULT_UNIT_ID,
      selectedMemberId: null,
      selectedTopicType: DEFAULT_TOPIC_TYPE,
      selectedTopicSubType: DEFAULT_TOPIC_TYPE,
      selectedPopularity: 0,
      selectedState: DEFAULT_TOPIC_STATE,
      searchPeriod: [],
      searchText: null,
      currentPage: 1,
      totalPages: 1,
      topics: [],
      viewType: "card",
    };
  },
  methods: {
    async onMemberChange(change) {
      this.selectedUnitId = change.unitId;
      this.selectedMemberId = change.memberId;

      await this.onClickSearch();
    },
    async onClickSearch() {
      const queryParams = {
        unitId: this.selectedUnitId,
        artistId: this.selectedMemberId || undefined,
        topicType: this.selectedTopicType || undefined,
        topicSubtype: this.selectedTopicSubType || undefined,
        state: this.selectedState,
        popularity: this.selectedPopularity || 0,
        searchText: this.searchText || undefined,
      };

      if (this.searchPeriod) {
        queryParams.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).format("YYYY-MM-DD") : undefined;
        queryParams.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).format("YYYY-MM-DD") : undefined;
      }

      try {
        await this.$router.push(`/topic/contents?${URLUtils.objectToQueryString(queryParams)}`);
      } catch (err) {
        // 같은 경로인 경우 error 가 발생합니다.
        // naive 한 방법이긴 하지만, 이런 경우 단순히 reload 합니다.
        await this.getTopics();
      }
    },
    getSearchParams() {
      return {
        unitId: this.selectedUnitId,
        artistId: this.selectedMemberId || undefined,
        topicType: this.selectedTopicType || undefined,
        topicSubtype: this.selectedTopicSubType || undefined,
        state: this.selectedState,
        isHot: this.selectedPopularity === 1,
        currentPage: this.currentPage || 1,
        startTime: this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString(true) : undefined,
        endTime: this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString(true) : undefined,
        searchText: this.searchText || undefined,
      };
    },
    async getTopics() {
      try {
        const queryParams = this.getSearchParams();
        const result = await this.$axios.get(`/topics?${URLUtils.objectToQueryString(queryParams)}`);
        this.topics = result.data.data.topics.map((row) => {
          row.regTime = formatDateTime(row.regTime);
          if (row.talk) {
            const subtype = row.talk.subtype;
            row.talk.subtypeName = TopicTalkTypeOptions.filter((option) => option.value === subtype)[0].label;
          }
          return row;
        });
        this.totalPages = Number(result.data.data.page);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    onClickDetail(topic) {
      this.$router.push(`/topic/detail/${topic.id}`);
    },
    async onClickDelete(topic) {
      swal
        .fire({
          title: "삭제 확인",
          text: `${topic.title} 토픽을 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              Toast.success("토픽이 삭제되었습니다.");
              await this.$axios.delete(`/topics/${topic.id}`);
              await this.getTopics();
            } catch (err) {
              Toast.error("토픽 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.row {
  margin-bottom: 10px;
}

.list {
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: 100%;

  .topic-cell {
    padding: 3px;
    flex-direction: column;
    flex-basis: 25%;
    max-height: 420px;
    min-width: 256px;
    margin-bottom: 30px;

    div {
      min-height: 30px;
    }

    .topic-card {
      margin-bottom: 0;
    }

    .cover-img-area {
      min-height: 150px;
      vertical-align: middle;

      .a-or-b {
        img {
          flex: auto;
          width: 100px;
          height: 100px;
          object-fit: cover;
        }
        img:nth-child(2) {
          margin-right: 5px;
        }
      }

      .tips {
        img {
          flex: auto;
          width: 100px;
          height: 100px;
          object-fit: cover;
        }
      }
    }

    .metadata {
      min-height: 100px;
    }

    .delete {
      margin-top: 5px;
    }
  }
}
</style>
